export enum ProductName {
    HOHHInsurance = 'HOHH Insurance',
    HOHHTakaful = 'HOHH Takaful',
    MyRumahInsurance = 'MyRumah Insurance',
    MyRumahTakaful = 'MyRumah Takaful',
  }
  